import { SUPPORTED_LANGS } from '../config/langResources';

// 앱 전체 언어 선택 목록의 단일 출처 (3-letter DB 코드 = SUPPORTED_LANGS 값). native 라벨.
export const PRELOGIN_LANG_OPTIONS = [
    { code: 'eng', label: 'English' },
    { code: 'kor', label: '한국어' },
    { code: 'jpn', label: '日本語' },
    { code: 'cmn', label: '简体中文' },
    { code: 'zhh', label: '繁體中文' },
    { code: 'deu', label: 'Deutsch' },
    { code: 'spa', label: 'Español' },
    { code: 'fre', label: 'Français' },
    { code: 'ita', label: 'Italiano' },
    { code: 'slk', label: 'Slovenčina' },
    { code: 'pol', label: 'Polski' },
    { code: 'ron', label: 'Română' },
    { code: 'ces', label: 'Čeština' },
    { code: 'por', label: 'Português' },
    { code: 'swe', label: 'Svenska' },
    { code: 'ell', label: 'Ελληνικά' },
    { code: 'tur', label: 'Türkçe' },
    { code: 'rus', label: 'Русский' },
    { code: 'kaz', label: 'Қазақ' },
];

const STORAGE_KEY = 'preLoginLang';
const DEFAULT_LANG = 'eng';

// navigator.language(BCP47) → 3-letter DB 코드
const BROWSER_TO_DB = {
    en: 'eng', ko: 'kor', ja: 'jpn', de: 'deu', es: 'spa', fr: 'fre',
    it: 'ita', sk: 'slk', pl: 'pol', ro: 'ron', cs: 'ces', pt: 'por',
    sv: 'swe', el: 'ell', tr: 'tur', ru: 'rus', kk: 'kaz',
    zh: 'cmn', 'zh-cn': 'cmn', 'zh-sg': 'cmn', 'zh-hans': 'cmn',
    'zh-tw': 'zhh', 'zh-hk': 'zhh', 'zh-mo': 'zhh', 'zh-hant': 'zhh',
};

export const isSupportedLang = (code) => !!code && SUPPORTED_LANGS.includes(code);

// 옛 ISO 코드 → 앱 코드. 읽을 때만 바꾸고 DB 값은 건드리지 않는다.
const LEGACY_LANG_MAP = { cze: 'ces', gre: 'ell', rum: 'ron', slo: 'slk' };

// 지원 코드면 그 코드, 아니면 null. 빈 값·문자열이 아닌 값도 null (순수 함수, warn 없음).
export const normalizeLangCode = (code) => {
    if (typeof code !== 'string' || !code) return null;
    const mapped = Object.prototype.hasOwnProperty.call(LEGACY_LANG_MAP, code) ? LEGACY_LANG_MAP[code] : code;
    return isSupportedLang(mapped) ? mapped : null;
};

// RayForm select 용 {code, title} 목록.
export const LANG_SELECT_OPTIONS = PRELOGIN_LANG_OPTIONS.map(({ code, label }) => ({ code, title: label }));

// 선택 상자에 넘길 값. 지원 밖 값도 그대로 두어 보이는 값 = 저장 값을 지킨다.
export const langSelectValue = (val) => normalizeLangCode(val) || (val ? String(val) : '');

// 비었거나 19개 밖인 값이면 그 값을 맨 앞 1줄로 보탠다. 호출마다 새 배열.
export const langSelectOptions = (val) => {
    const v = langSelectValue(val);
    if (isSupportedLang(v)) return [...LANG_SELECT_OPTIONS];
    return [{ code: v, title: v || '-' }, ...LANG_SELECT_OPTIONS];
};

export const detectBrowserLang = () => {
    try {
        const nav = (typeof navigator !== 'undefined' &&
            (navigator.language || (navigator.languages && navigator.languages[0]))) || '';
        const lower = String(nav).toLowerCase();
        if (BROWSER_TO_DB[lower]) return BROWSER_TO_DB[lower];
        const primary = lower.split('-')[0];
        if (BROWSER_TO_DB[primary]) return BROWSER_TO_DB[primary];
    } catch (e) {
        console.warn('[preLoginLang] detectBrowserLang failed', e);
    }
    return DEFAULT_LANG;
};

// 저장된 선호도 반환. 없으면 브라우저 감지값을 저장 후 반환. 항상 지원 코드 보장.
export const getPreLoginLang = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (isSupportedLang(stored)) return stored;
        const detected = detectBrowserLang();
        localStorage.setItem(STORAGE_KEY, detected);
        return detected;
    } catch (e) {
        console.warn('[preLoginLang] getPreLoginLang failed', e);
        return DEFAULT_LANG;
    }
};

export const setPreLoginLang = (code) => {
    try {
        if (isSupportedLang(code)) localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {
        console.warn('[preLoginLang] setPreLoginLang failed', e);
    }
};
